<div
  class="radio-card-group-wrapper"
  [class.horizontal]="layout === 'horizontal'"
  [ngClass]="customWrapperClass"
>
  <label *ngIf="label" class="group-label">
    {{ label }}<span *ngIf="isRequired" class="req">*</span>
  </label>
  <p *ngIf="description" class="group-desc">{{ description }}</p>

  <div
    class="options-container"
    [style.gap]="gap"
    [class.horizontal]="layout === 'horizontal'"
  >
    <div
      *ngFor="let option of options; let i = index"
      class="radio-card"
      [class.selected-primary]="
        isSelected(option) && (!option.variant || option.variant === 'primary')
      "
      [class.selected-danger]="
        isSelected(option) &&
        (option.variant === 'danger' || option.variant === 'cancel')
      "
      [class.selected-warning]="
        isSelected(option) && option.variant === 'warning'
      "
      [class.disabled]="disabled || option.disabled"
      (click)="selectOption(option)"
    >
      <div
        class="radio-circle"
        [class.primary]="!option.variant || option.variant === 'primary'"
        [class.danger]="
          option.variant === 'danger' || option.variant === 'cancel'
        "
        [class.warning]="option.variant === 'warning'"
      >
        <div
          class="radio-inner"
          *ngIf="isSelected(option)"
          [class.primary]="!option.variant || option.variant === 'primary'"
          [class.danger]="
            option.variant === 'danger' || option.variant === 'cancel'
          "
          [class.warning]="option.variant === 'warning'"
        ></div>
      </div>

      <div class="card-content">
        <div class="card-title">{{ option.title || option.label }}</div>
        <div class="card-desc" *ngIf="option.description || option.desc">
          {{ option.description || option.desc }}
        </div>
      </div>
    </div>
  </div>
</div>
